import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { AnyFormValues } from '@funnels/types';

/**
 * Basing one the business logic, the current residential address and
 * mailing address of formValues can also impact the state of useAsMailingAddress
 * checkbox. We only need to consider the case when both currentResidentialAddress and
 * mailingAddress are there, because both of them are mandatory now.
 */
export default function getStateOfUseAsMailingAddressCheckboxToOverride(
  formValues: AnyFormValues,
  applicantIndex: number
) {
  const currentResidentialAddressFormatted = get(
    formValues,
    FIELD_PATHS.APPLICANT_CURRENT_ADDRESS_RESIDENTIAL_FORMATTED(applicantIndex),
    ''
  );
  const mailingAddressFormatted = get(formValues, FIELD_PATHS.APPLICANT_MAILING_ADDRESS_FORMATTED(applicantIndex), '');

  if (currentResidentialAddressFormatted && mailingAddressFormatted) {
    return currentResidentialAddressFormatted === mailingAddressFormatted;
  }
  return undefined;
}
